import { OfflinePrefetchProps } from "../interface";
import {
  usePrefetchUtils,
  executePaginatedPrefetch,
} from "../utils/usePrefetchUtils";
import { useLazyBowelMovementHistoryQuery } from "../../../api/staticFormsApi";
import { storeBowelMovements } from "../../../../store/slices/bowelMovements";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { format, subDays } from "date-fns";
import { store } from "app/services/store";
import { BASE_DAYS } from "./constants";

const HISTORY_DATE_FROM_DAYS = BASE_DAYS; // 15 days

export function usePrefetchBowelMovements({ enabled }: OfflinePrefetchProps) {
  const [trigger] = useLazyBowelMovementHistoryQuery();
  const dispatch = useDispatch();

  const handlePrefetch = useCallback(async () => {
    const dateFrom = format(
      subDays(new Date(), HISTORY_DATE_FROM_DAYS),
      "yyyy-MM-dd",
    );

    await executePaginatedPrefetch({
      name: "BowelMovements",
      trigger,
      buildQueryArgs: (page) => ({
        filter: {
          date_from: dateFrom,
        },
        limit: 100,
        page,
      }),
      storeData: (data) => dispatch(storeBowelMovements(data)),
      getLastPage: (data) => data?.meta?.last_page ?? 1,
      enableSmartCache: true,
      getFirstRecordId: (data) => data?.data?.[0]?.id ?? null,
      dispatch,
      getState: () => store.getState(),
    });
  }, [trigger, dispatch]);

  usePrefetchUtils({
    enabled,
    prefetchHandler: handlePrefetch,
  });
}
